import React from 'react';
import { Alert, Box, Typography, useTheme } from '@mui/material';

import i18n from 'translation';

import { defaultSettings, HeadlineSettingsDialog } from './HeadlineSettingsDialog';
import withOptionsWidget, { WithOptionsWidgetProps } from 'components/widgetParts/withOptionsWidget';

// This widget displays a headline text and a subtext based on the user's input
function HeadlineContent(props: WithOptionsWidgetProps): JSX.Element {
  const theme = useTheme();
  const currentState = {
    ...defaultSettings,
    ...props.widget?.data,
    ...props.widget?.data?.settings
  };

  return (
    <Box sx={{  position: "absolute", top: "0", left: "0", width: "100%", height: "100%",  backgroundColor: currentState.backgroundColor || "transparent" }}>
      <Box sx={{ position: "absolute",  top: "50%", width: "100%", transform: "translate(0, -50%)" }}>
        {currentState.headlineTitle &&
          <Typography variant="h1" sx={{ textAlign: "center", color: currentState.headlineColor || theme.palette.text.primary }}>
            {currentState.headlineTitle}
          </Typography>
        }
        {currentState.headlineSubtext &&
          <Typography
            variant="h3"
            sx={{
              textAlign: "center",
              fontWeight: "normal",
              color: currentState.subtextColor || theme.palette.text.primary
            }}>
            {currentState.headlineSubtext}
          </Typography>
        }
      </Box>
      {(!currentState.headlineTitle && !currentState.headlineSubtext) &&
        <Alert severity="info" sx={{ margin: "20px", backgroundColor: theme.palette.background.default }}>
          {i18n.t("widgets.missing-settings-error")}
        </Alert>
      }
      {props.settingsDialogIsOpen &&
        <HeadlineSettingsDialog {...props} />
      }
    </Box>
  );
}

export default withOptionsWidget(HeadlineContent, { hasSettingsDialog: true });